import axios, { type AxiosRequestConfig } from 'axios'
import { toast } from 'react-toastify'
import { logError } from '../utils/sentry'

export interface ApiRequestConfig extends AxiosRequestConfig {
  silentAuthCheck?: boolean
}

// const baseURL = 'https://backend.porygon.techtio.work'
const baseURL = import.meta.env.VITE_BACKEND_HOST

const api = axios.create({
  baseURL,
  timeout: 10000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

api.interceptors.request.use(
  (config) => config,
  (error) => {
    logError('API Request Error', error)
    console.error('API Request Error:', error)
    return Promise.reject(error)
  },
)

api.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    console.error('API Response Error:', {
      url: error.config?.url,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      message: error.message,
    })

    logError('API Response Error', error)

    const cfg = (error.config ?? {}) as ApiRequestConfig
    const isSilentAuthCheck = Boolean(cfg.silentAuthCheck)

    if (error.response?.status === 401 && !isSilentAuthCheck) {
      toast.error('Session expired. Please login again.', { toastId: 'auth-401' })
    }

    if (!isSilentAuthCheck) {
      if (error.response?.data?.message) {
        toast.error(error.response.data.message)
      } else if (error.response?.status === 403) {
        toast.error('Access denied.')
      } else if (error.response?.status === 404) {
        toast.error('Resource not found.')
      } else if (error.response?.status >= 500) {
        toast.error('Server error. Please try again later.')
      }
    }

    return Promise.reject(error)
  },
)

export default api
